import React from 'react'
import Footer from '../Footer'
import OneChestNut from '../OneChestNut'

function ImgOneChestNut() {
    window.scrollTo(0,0);
    return (
        <>
        <OneChestNut/>
        <Footer/>
            
        </>
    )
}

export default ImgOneChestNut
